<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Insights</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <!-- <div class="divider"></div>
      <div class="filter">
        <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
          <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
        </button>
      </div> -->
    <div class="divider"></div>
    <lhpe-select
      controlName="signal"
      placeholder="Signal"
      [formGroup]="signalForm"
      [options]="filteredSignals"
      displayValue="name"
      [optionIsSelf]="true"
    >
    </lhpe-select>
    <div class="divider"></div>
    <lhpe-input
      controlName="signalSearch"
      placeholder="Signal search"
      [formGroup]="signalForm"
    >
    </lhpe-input>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="insights">
  <div class="columns">
    <div class="column icon-info-column">
      <div class="container icon-info-container location-allowed-container">
        <div class="container-header no-bottom-border">
          <div class="text">Mobile location</div>
        </div>

        <div class="container-content">
          <div class="row">
            <div class="icon">
              <svg-icon
                src="assets/svg/exec-summary/mobile-location.svg"
              ></svg-icon>
            </div>
            <div class="graph">
              <div
                echarts
                [options]="mobileLocationChartOption"
                class="pie-chart"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container icon-info-container installs-container">
        <div class="container-header no-bottom-border">
          <div class="text">Installs</div>
        </div>

        <div class="container-content">
          <div class="row">
            <div class="icon">
              <svg-icon src="assets/svg/exec-summary/installs.svg"></svg-icon>
              <div class="text">{{ installs ? installs : "0" }}</div>
            </div>
            <div class="graph">
              <div
                echarts
                [options]="installsChartOptions"
                class="bar-chart"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column redemptions-category-column">
      <div
        *ngIf="signalForm.controls.signal.value"
        class="container redemptions-container"
      >
        <div class="container-header no-bottom-border">
          <div class="text">
            Redemptions for {{ signalForm.controls.signal.value?.name }}
          </div>
        </div>
        <div class="container-content">
          <div
            echarts
            [options]="redemptionChartOptions"
            class="line-chart"
          ></div>
        </div>
      </div>
      <div class="container deliveries-category-container">
        <div class="container-header no-bottom-border">
          <div class="text">Deliveries by category</div>
        </div>
        <div class="container-content">
          <div class="pie-graphs">
            <ng-container *ngIf="categoryCharts && categoryCharts.length">
              <div *ngFor="let chart of categoryCharts" class="pie-graph">
                <div
                  echarts
                  [options]="chart.chartOptions"
                  class="pie-chart"
                ></div>
                <div class="text">{{ chart.name }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="!(categoryCharts && categoryCharts.length)">
              <div class="no-deliveries">No deliveries in this range</div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="column icon-info-column">
      <div class="container deliveries-geofence-container">
        <div class="container-header no-bottom-border">
          <div class="text">Deliveries by geofence</div>
          <div class="options">
            <button mat-icon-button [matMenuTriggerFor]="deliveriesMenu">
              <svg-icon src="assets/svg/ellipsis-white.svg"></svg-icon>
            </button>
            <mat-menu
              class="mat-menu-elaphant vertical-menu"
              #deliveriesMenu="matMenu"
            >
              <mat-radio-group
                class="mat-lightGreen"
                aria-label="Select an option"
                [(ngModel)]="deliveryGeofenceSortType"
                (change)="sortDeliveriesByGeofences()"
              >
                <mat-radio-button value="high_to_low" class="mat-lightGreen"
                  >High to Low</mat-radio-button
                >
                <mat-radio-button value="low_to_high" class="mat-lightGreen"
                  >Low to High</mat-radio-button
                >
              </mat-radio-group>
            </mat-menu>
          </div>
        </div>
        <div class="container-content">
          <div *ngFor="let delivery of geofenceDeliveries" class="field">
            <div class="info">
              <div class="message">{{ delivery.name }}</div>

              <div class="amt">
                {{ delivery.deliveries }} of {{ geofenceDeliveriesTotal }}
              </div>
            </div>
            <div class="bar">
              <div class="bar-background"></div>
              <div
                class="bar-progress"
                [ngStyle]="{
                  'width.%':
                    (delivery.deliveries / geofenceDeliveriesTotal) * 100
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
